import { Stack, Checkbox, Typography, FormControlLabel } from '@mui/material';
import { Controller, FieldValues, Path, PathValue, Validate } from 'react-hook-form';

import { BaseInputProps } from './GetFormInput';

export function FormCheckbox<T extends FieldValues>({
    control,
    disabled,
    helperText,
    label,
    required,
    validation,
    value,
}: Readonly<BaseInputProps<T>>) {
    return (
        <Controller
            control={control}
            name={value}
            render={({ field: { onBlur, onChange, ref, value }, fieldState: { error } }) => (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={value as boolean}
                            disabled={disabled}
                            onBlur={onBlur}
                            onChange={onChange}
                            ref={ref}
                        />
                    }
                    label={label}
                />
            )}
            rules={{
                required: required ? `${label ?? value} cannot be empty` : false,
                validate: validation as unknown as
                    | Validate<PathValue<T, Path<T>>, T>
                    | Record<string, Validate<PathValue<T, Path<T>>, T>>,
            }}
        />
    );
}
